/**
 * oss图片处理参数，用于图片缩放
 * @link https://help.aliyun.com/zh/oss/user-guide/resize-images-4
 * @param {string} url 
 * @param {{ w?: number; h?: number }} params 具体看文档，一般传入一个对象，如：{w: 100, h: 100}
 * @returns {string}
 */
export default function ossImgParams(url, params) {
  try {
    let urlIns = new URL(url);

    if (Object.keys(params).length === 0) {
      console.warn('没有传入参数，直接返回原始地址')
      return url;
    }

    params = Object.assign(
      // 默认参数
      {
        m: "lfit",
      },
      params
    );

    let valStr = `image/resize`;

    Object.keys(params).forEach((key) => {
      valStr += `,${key}_${params[key]}`;
    });

    urlIns.searchParams.set("x-oss-process", valStr);

    return urlIns.href;
  } catch (error) {
    console.log(error);
    return url;
  }
}
